(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["serendipia-product-back"] && !Shopify.designMode) return;
  try {
    if(!window.serendipiaProductBackReady){
window.serendipiaProductBackReady=true;
document.addEventListener('click',function(event){
const link=event.target.closest('[data-serendipia-back]');
if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
try{
if(document.referrer&&new URL(document.referrer).origin===location.origin&&history.length>1){
event.preventDefault();
history.back();
}
}catch{}
});
}
  } catch(e) { console.error(e); }
})();

})();
